<tabset class="nav nav-tabs admin-tab cs-secondary-tabs maintab-fbo" role="tablist">
      <tab autofocus (select)="selectTab(1)" [active]="activeTab==1"
            heading="{{'customer-service.Search Department'|translate | translateKey}}" customClass="product-tabs"
            tabTitle="FBO Profile">
            <customer-department-search *ngIf="activeTab==1"></customer-department-search>
      </tab>
      <tab autofocus (select)="selectTab(2)" [active]="activeTab==2"
            heading="{{'customer-service.Add Department'|translate | translateKey}}" customClass="product-tabs"
            tabTitle="Add Department" *ngIf="addDepartmentPermission">
            <department *ngIf="activeTab==2"></department>
      </tab>
</tabset>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/admin/department-tabs.html